import { gsap } from '../animations';

/**
 * Animazioni d'ingresso del block "Camere":
 * - intestazione (titolo + lead/chip) in fade-up a stagger;
 * - carousel in fade-up all'ingresso nel viewport.
 * Il drag/lightbox del carousel sono gestiti dai moduli condivisi (initCarousels,
 * initLightbox). Con reduced-motion resta tutto fermo e visibile.
 */
export function initCamere() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-tm-camere]' ).forEach( ( block ) => {
		const head = block.querySelector( '[data-tm-camere-head]' );
		if ( head && head.children.length ) {
			gsap.from( head.children, {
				y: 24,
				opacity: 0,
				duration: 0.7,
				ease: 'power3.out',
				stagger: 0.12,
				scrollTrigger: { trigger: head, start: 'top 84%', once: true },
			} );
		}

		const carousel = block.querySelector( '[data-tm-carousel]' );
		if ( carousel ) {
			gsap.from( carousel, {
				y: 28,
				opacity: 0,
				duration: 0.8,
				ease: 'power3.out',
				scrollTrigger: { trigger: carousel, start: 'top 88%', once: true },
			} );
		}
	} );
}
